/// <reference path="../../setup/_references.ts" />
module onvio.reports.firmManagementReports {
    'use strict';

    export interface ReportRequest {
        download: boolean;
        sendToDms: boolean;
        preview: boolean;
        jobId: string;
        postRequestBody: any;
    }
    export interface ReportRequestResponse {
        jobId: string;
        status: ReportJobStatus;
        error: string;
    }

    export enum ReportJobStatus {
        SUCCEEDED = 'SUCCEEDED',
        FAILED = 'FAILED'
    }

    export class FirmManagementReportsListService implements bluemoon.reporting.IReportController {

        static $inject = ['AuthenticatedSessionData', '$q', 'csReportDefinitionBasicsV1', 'onvio.reports.firmManagementReports.FirmManagementReportsSocketService', 'bmAccess'];

        private loadedCompanyId: string;
        private useNewAsync: boolean = false;

        private promiseResolve: any;
        private createDocumentApipromiseResolve: any;
        constructor(private authenticatedSessionData: any, private $q: ng.IQService, private reportDefinitionBasicV1: cs.IReportDefinitionBasicsV1Service, private socketService: onvio.reports.firmManagementReports.FirmManagementReportsSocketService,
        private bmAccess: any) {
            var vm = this;
            authenticatedSessionData.get().then((sessionData: any) => { // TODO - ng161 - handle reject
                vm.loadedCompanyId = sessionData.bindings.ApplicationConfiguration.CompanyId;
            });
            $q.all([this.bmAccess.not('OnvioCenter.DisableFirmManagementReportAsync')])
                .then(function() {
                    vm.useNewAsync = true;
                }).catch(function() {
                    vm.useNewAsync = false;
                });
        }

        public useNewAsyncMode(): boolean
        {
            return this.useNewAsync;
        }

        public insertIntoSocketSrvTracing(jobId: string, payload: any) {
            var mapping: ReportRequest = {
                download: payload.isDownload,
                sendToDms: payload.sendToDms,
                preview: payload.isPreview,
                jobId: jobId,
                postRequestBody: payload
            }
            this.socketService.socketSrvTracing.set(jobId, mapping);
        }

        public processCreateDocumentRequestToSocketSrv(jobId: string, isSubscribe: boolean = true) {
            // init the connection to SocketServices
            if (this.useNewAsync && !this.socketService.socketOk && isSubscribe) {
                this.socketService.registerErrorCallbacks(this.handleSocketConnectError.bind(this));
                this.socketService.init();
                this.socketService.registerCallback(this.onSocketReceive);
            }

            isSubscribe ? this.socketService.sendMessage("route:com.tr.bluemoon.event.coreservices.reportrequest.completed.v1:" + jobId) : this.socketService.sendMessage("unroute:com.tr.bluemoon.event.coreservices.reportrequest.completed.v1:" + jobId);
            if (!isSubscribe) {
                this.socketService.socketSrvTracing.delete(jobId);
            } else {
                this.socketService.activeSocketMsg.jobId = jobId;
            }
        }

        /* query for the report list */
        public getReportList(params: cs.IQueryFilter): ng.IPromise<cs.IPagedItemsDto<cs.IReportDefinitionBasicsV1Dto>> {
            params.filter = new bmp.Filter().where('reportLayoutType.id').equals('STANDARDREPORT').toString();
            return this.reportDefinitionBasicV1.postSearch(bmp.PostSearchUtils.convertGetListParamsToSearchParams(params));
        }

        public getCreateDocumentRequestUrl(): ng.IPromise<string> {
            return this.getCompanyId().then((companyId: string) => {
                var url = '/api/core-reporting-services/v1/companies/{companyId}/reports/create-document'
                    .replace('{companyId}', companyId);
                return url;
            });
        }

        public getSocketServicePromise(): ng.IPromise<any> {
            return new Promise<any>((resolve, reject) => {
                this.promiseResolve = resolve;
            });
        };

        public getCreateDocumentApipromise(): ng.IPromise<any> {
            return new Promise<any>((resolve, reject) => {
                this.createDocumentApipromiseResolve = resolve;
            });
        };

        public closeSocketConnection(): void {
            this.socketService.close();
        };

        public getSecuredReportPreviewUrl(): ng.IPromise<string> {
            if (!this.useNewAsync) {
                return this.getCompanyId().then((companyId: string) => {
                    var url = '/api/core/v1/companies/{companyId}/reports/document-preview-url'
                        .replace('{companyId}', companyId);
                    return url;
                });
            } else {
                return this.getCompanyId().then((companyId: string) => {
                    var url = '/api/core-reporting-services/v1/companies/{companyId}/reports/document-preview-url'
                        .replace('{companyId}', companyId);
                    return url;
                });
            }
        }

        public getSecuredReportDownloadUrl(): ng.IPromise<string> {
            if (!this.useNewAsync) {
                return this.getCompanyId().then((companyId: string) => {
                    var url = '/api/core/v1/companies/{companyId}/reports/document-download-url'
                        .replace('{companyId}', companyId);
                    return url;
                });
            } else {
                return this.getCompanyId().then((companyId: string) => {
                    var url = '/api/core-reporting-services/v1/companies/{companyId}/reports/document-download-url'
                        .replace('{companyId}', companyId);
                    return url;
                });
            }
        }

        public getSendReportToOnvioDocumentsUrl(): ng.IPromise<string> {
            if (!this.useNewAsync) {
                return this.getCompanyId().then((companyId: string) => {
                    var url = '/api/core/v1/companies/{companyId}/reports/document-path'
                        .replace('{companyId}', companyId);
                    return url;
                });
            } else {
                return this.getCompanyId().then((companyId: string) => {
                    var url = '/api/core-reporting-services/v1/companies/{companyId}/reports/document-path'
                        .replace('{companyId}', companyId);
                    return url;
                });
            }
        }

        /**
         * Builds the URL for  report option editing screen.
         * Needs to include any parameters because this screen will be app-specific.
         */
        public getEditReportOptionsUrl(reportListItem: cs.IReportDefinitionBasicsV1Dto): string {
            if (reportListItem.employeeReportOptionList.length > 0) {
                return '#/firm-management-reports-options/' + reportListItem.id + '/' + reportListItem.employeeReportOptionList[0];
            }

            return '#/firm-management-reports-options-add/' + reportListItem.id;
        }

        private getCompanyId() {

            if(angular.isDefined(this.loadedCompanyId)) {
                return this.$q.when(this.loadedCompanyId);
            }

            if (angular.isDefined(this.authenticatedSessionData.bindings) &&
                angular.isDefined(this.authenticatedSessionData.bindings.ApplicationConfiguration) &&
                angular.isDefined(this.authenticatedSessionData.bindings.ApplicationConfiguration.CompanyId)) {
                this.loadedCompanyId = this.authenticatedSessionData.bindings.ApplicationConfiguration.CompanyId;
                return this.$q.when(this.loadedCompanyId);
            }

            var self = this;
            return this.authenticatedSessionData.getBindings().then((bindings: any) => {
                self.loadedCompanyId = bindings.ApplicationConfiguration.CompanyId;
                return self.loadedCompanyId;
            });
        }

        private onSocketReceive = (data: string) => {
            try {
                var event: CloudEvent = JSON.parse(data);

                if (event) {
                    switch (event.Type) {
                        case "com.tr.bluemoon.event.coreservices.reportrequest.completed.v1":
                            var responseData = event.Data as ReportRequestResponse;
                            if (responseData.status !== ReportJobStatus.SUCCEEDED) {
                                this.promiseResolve(false);
                            }
                            else {
                                var mapping = this.socketService.socketSrvTracing.get(responseData.jobId);
                                this.promiseResolve(mapping);
                            }
                            this.socketService.socketSrvTracing.delete(responseData.jobId);
                            this.socketService.sendMessage("unroute:com.tr.bluemoon.event.coreservices.reportrequest.completed.v1:" + responseData.jobId);
                            break;
                    }
                }

            }
            catch (exc) {
                if (data.indexOf('added: com.tr.bluemoon.event.coreservices.reportrequest') > -1) {
                    this.socketService.activeSocketMsg.received = true;
                }
                if (this.socketService.activeSocketMsg.received && this.socketService.activeSocketMsg.jobId) {
                    var mapping = this.socketService.socketSrvTracing.get(this.socketService.activeSocketMsg.jobId);
                    this.socketService.activeSocketMsg = {
                        jobId: null,
                        received: false
                    };
                    this.createDocumentApipromiseResolve(mapping);
                }
            }
        };

        public handleSocketConnectError() {
            this.createDocumentApipromiseResolve(false);
            this.promiseResolve(false);
        }
    }

    angular.module('onvio.reports.firmManagementReports.FirmManagementReportsListService',
        ['csReportDefinitionBasicsV1','onvio.reports.firmManagementReports.FirmManagementReportsSocketService','bmAccess'])
        .service('onvio.reports.firmManagementReports.FirmManagementReportsListService',
            FirmManagementReportsListService);
}
